import { ErrorMessage } from "lib/formik"
import React from "react"
import { useTranslation } from "react-i18next"

const TextError = ({ name }) => {
  const { t } = useTranslation()

  return (
    <ErrorMessage name={name}>
      {msg =>
        typeof msg === "string" ? (
          <div className="error text-danger">{t(msg)}</div>
        ) : null
      }
    </ErrorMessage>
  )
}

export default TextError
